import { useMutation } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';

const MUTATION = graphql(`
  mutation deletePageRule($id: ID!) {
    softDeletePageRule(id: $id) {
      id
    }
  }
`);

export function useDeletePageRule() {
  return useMutation(MUTATION, {
    refetchQueries: ['PrintRule'],
  });
}
